import { MemreFlexBox, MemreInput } from 'components/core';
import { useState } from 'react';
const FALLBACK_IMAGE = 'http://localhost:3002/app/static/media/afternoon-header.50d572deef5e52f10372.png';

export default function ImageByUrl({ setSelectedImage }) {
  const [imageUrl, setImageUrl] = useState(FALLBACK_IMAGE);
  const [showFallback, setShowFallback] = useState(false);

  const handleInputChange = (newUrl) => {
    setImageUrl(newUrl);
    setShowFallback(false);
  };

  const handleImageError = () => {
    setShowFallback(true);
    setImageUrl(FALLBACK_IMAGE);

    setSelectedImage(null);
  };

  const onImageLoad = () => {
    if (imageUrl !== FALLBACK_IMAGE) {
      setSelectedImage(imageUrl);
    }
  };

  return (
    <MemreFlexBox direction="column" sx={{ width: '100%' }} gap={2}>
      <MemreInput label="Image URL" onValueChange={handleInputChange} />
      <div
        style={{
          backgroundImage: `url(${showFallback ? FALLBACK_IMAGE : imageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          width: '100%',
          flex: 1,
        }}
      />
      <img
        src={showFallback ? FALLBACK_IMAGE : imageUrl}
        alt="Test image"
        onError={handleImageError}
        onLoad={onImageLoad}
        style={{ display: 'none' }}
      />
    </MemreFlexBox>
  );
}
